export enum STRAND_TYPE {
  SENSE = 'sense',
  ANTISENSE = 'antisense',
}
